import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, X, ShoppingBag, Heart, User } from 'lucide-react';
const Layout: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  return <div className="min-h-screen flex flex-col bg-gray-50" data-id="element-18">
      {/* Header */}
      <header className="bg-white shadow-sm" data-id="element-19">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-20">
          <div className="flex justify-between items-center h-16" data-id="element-21">
            {/* Logo */}
            <div className="flex-shrink-0" data-id="element-22">
              <Link to="/" className="flex items-center" data-id="element-23">
                <ShoppingBag className="h-8 w-8 text-brand-600" data-id="element-24" />
                <span className="ml-2 text-xl font-bold text-gray-900" data-id="element-25">
                  FayMarket
                </span>
              </Link>
            </div>
            {/* Desktop Navigation */}
            <nav className="hidden md:flex space-x-8" data-id="element-26">
              <Link to="/" className={`${location.pathname === '/' ? 'text-brand-600 border-brand-600' : 'text-gray-500 border-transparent'} border-b-2 hover:text-brand-600 px-1 pt-1 font-medium`} data-id="element-27">
                Home
              </Link>
              <Link to="/products" className={`${location.pathname === '/products' ? 'text-brand-600 border-brand-600' : 'text-gray-500 border-transparent'} border-b-2 hover:text-brand-600 px-1 pt-1 font-medium`} data-id="element-28">
                Products
              </Link>
              <Link to="/submit-product" className={`${location.pathname === '/submit-product' ? 'text-brand-600 border-brand-600' : 'text-gray-500 border-transparent'} border-b-2 hover:text-brand-600 px-1 pt-1 font-medium`} data-id="element-29">
                For Dietitians
              </Link>
            </nav>
            {/* Mobile menu button */}
            <div className="md:hidden" data-id="element-30">
              <button type="button" className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-brand-500" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-31">
                <span className="sr-only" data-id="element-32">Open main menu</span>
                {mobileMenuOpen ? <X className="block h-6 w-6" aria-hidden="true" data-id="element-33" /> : <MenuIcon className="block h-6 w-6" aria-hidden="true" data-id="element-34" />}
              </button>
            </div>
          </div>
        </div>
        {/* Mobile menu */}
        {mobileMenuOpen && <div className="md:hidden" data-id="element-35">
            <div className="pt-2 pb-3 space-y-1" data-id="element-36">
              <Link to="/" className={`${location.pathname === '/' ? 'bg-brand-50 border-brand-500 text-brand-700' : 'border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700'} block pl-3 pr-4 py-2 border-l-4 text-base font-medium`} onClick={() => setMobileMenuOpen(false)} data-id="element-37">
                Home
              </Link>
              <Link to="/products" className={`${location.pathname === '/products' ? 'bg-brand-50 border-brand-500 text-brand-700' : 'border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700'} block pl-3 pr-4 py-2 border-l-4 text-base font-medium`} onClick={() => setMobileMenuOpen(false)} data-id="element-38">
                Products
              </Link>
              <Link to="/submit-product" className={`${location.pathname === '/submit-product' ? 'bg-brand-50 border-brand-500 text-brand-700' : 'border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700'} block pl-3 pr-4 py-2 border-l-4 text-base font-medium`} onClick={() => setMobileMenuOpen(false)} data-id="element-39">
                For Dietitians
              </Link>
            </div>
          </div>}
      </header>
      {/* Main content */}
      <main className="flex-grow" data-id="element-40">{children}</main>
      {/* Footer */}
      <footer className="bg-white border-t border-gray-200" data-id="element-41">
        <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8" data-id="element-42">
          <div className="md:flex md:items-center md:justify-between" data-id="element-43">
            <div className="flex justify-center md:justify-start" data-id="element-44">
              <Link to="/" className="flex items-center" data-id="element-45">
                <ShoppingBag className="h-6 w-6 text-brand-600" data-id="element-46" />
                <span className="ml-2 text-lg font-bold text-gray-900" data-id="element-47">
                  FayMarket
                </span>
              </Link>
            </div>
            <div className="mt-8 md:mt-0 md:order-1" data-id="element-48">
              <p className="text-center text-base text-gray-500" data-id="element-49">
                &copy; {new Date().getFullYear()} FayMarket. All rights
                reserved.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>;
};
export default Layout;